export function formatNumber(n) {
  if (n === null || n === undefined) return "—";
  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + "B";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return String(n);
}

export function timeAgo(iso) {
  if (!iso) return "";
  const now = new Date();
  const then = new Date(iso);
  const diff = Math.floor((now - then) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
  return then.toLocaleDateString();
}

export function timeUntil(iso) {
  if (!iso) return "";
  const diff = Math.floor((new Date(iso) - new Date()) / 1000);
  if (diff <= 0) return "any moment";
  if (diff < 3600) return `in ${Math.max(1, Math.floor(diff / 60))}m`;
  if (diff < 86400) return `in ${Math.floor(diff / 3600)}h ${Math.floor((diff % 3600) / 60)}m`;
  return `in ${Math.floor(diff / 86400)}d`;
}


export function platformLabel(p) {
  return { instagram: "Instagram", tiktok: "TikTok", youtube: "YouTube Shorts" }[p] || p;
}

export function classNames(...args) {
  return args.filter(Boolean).join(" ");
}
